import api from '@/api/api';

export const atividadeOcorrenciaService = {
  getAtividadeOcorrencias,
  addAtividadeOcorrencia,
  finalizarAtividadeOcorrencia
};

function getAtividadeOcorrencias(id) {
  return api.get(`atividadesocorrencias/1/${id}`);
}

function addAtividadeOcorrencia(ocorrencia) {
  return api.post('atividadesocorrencias', ocorrencia);
}

function finalizarAtividadeOcorrencia(ocorrencia) {
  return api.put('atividadesocorrencias', {
    Acao: 'FinalizaAtividadeOcorrencia',
    IdAtividade: ocorrencia.IdAtividade,
    IdOcorrencia: ocorrencia.IdOcorrencia,
    IdTipoOcorrencia: ocorrencia.IdTipoOcorrencia,
    Descricao: ocorrencia.Descricao,
    Duracao: ocorrencia.Duracao
  });
}